import { useAppAccess } from "@/hooks/useAppAccess";
import { canAccessSolicitacaoPagamentoModule } from "@/lib/appAccess";

export function useSolicitacaoPagamentoAccess() {
  const { can, isAdmin, isMaster, hasFullAccess } = useAppAccess();

  const canAccessModule = canAccessSolicitacaoPagamentoModule(can);
  const canAprovarOperacional = can("solicitacaoPagamentoAprovar");
  const canAprovarFinanceira = can("solicitacaoPagamentoAprovarFinanceira");

  return {
    canAccessModule,
    /** Qualquer usuário com acesso ao módulo pode criar solicitações. */
    canSolicitar: canAccessModule,
    canAprovarOperacional,
    canAprovarFinanceira,
    /** Legado */
    canAprovar: canAprovarOperacional,
    isAdmin,
    isMaster,
    hasFullAccess,
  };
}
